import { API_BASE_URL, getAuthHeaders } from './pokemonCardOwnershipService';
import { CreateTradeInput, Trade } from '../types/Trade';

export const tradeService = {
  getTrades: async (): Promise<Trade[]> => {
    const headers = await getAuthHeaders();
    const response = await fetch(`${API_BASE_URL}/api/trades`, {
      headers,
    });
    if (response.status === 404) return [];
    if (!response.ok) throw new Error('Failed to fetch trades');
    return response.json();
  },

  saveTrade: async (trade: CreateTradeInput): Promise<Trade> => {
    const headers = await getAuthHeaders();
    const response = await fetch(`${API_BASE_URL}/api/trades`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...headers,
      },
      body: JSON.stringify(trade),
    });
    if (!response.ok) throw new Error('Failed to save trade');
    return response.json();
  },

  deleteTrade: async (tradeId: string): Promise<void> => {
    const headers = await getAuthHeaders();
    const response = await fetch(`${API_BASE_URL}/api/trades/${tradeId}`, {
      method: 'DELETE',
      headers,
    });
    if (!response.ok) throw new Error('Failed to delete trade');
  },
};
